import React from "react";
// import { Button } from "primereact/button";
// import { useFormik } from "formik";
// import classNames from "classnames";
// import { handlePostRequest } from "../../../services/PostTemplate";
// import MultipleFileUpload from "../../../components/multipleFileUpload/MultipleFileUpload";

const AddBulkBranch = () => {

    // const [loading, setloading] = useState(false);
    // const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    // const [uploadFile, setUploadFile] = useState("");

    // const formik = useFormik({
    //     validate: (data) => { },
    //     onSubmit: async (data) => {
    //         const fileBase64 = uploadFile?.fileBase64.split(";base64,").pop();
    //         setloading(true);
    //         setloadingIcon("pi pi-spin pi-spinner");
    //         data["productId"] = data?.productId?.id;
    //         data["parserId"] = data?.parserId?.id;
    //         data["fileBase64"] = fileBase64;
    //         data["fileName"] = uploadFile?.fileName;
    //         await handlePostRequest(data, "zbizgateway/customerFileUpload/productWiseBulkUpload");
    //         setloading(false);
    //         setloadingIcon("pi pi-save");
    //         formik.resetForm();
    //     },
    // });

    // const handleUpload = (files) => {
    //     console.log(files);
    // };

    // const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    return (
        <>
            {/* <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Add Bulk Branch</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="bankId" className={classNames({ "p-error": isFormFieldValid("bankId") }, "Label__Text")}>
                                    Upload File
                                </label>
                                <MultipleFileUpload handleUpload={handleUpload} isMulti={false} heading="Upload File" isConvert64={false} />
                            </div>
                        </div>
                    </div>
                </form>
                <div className="Down__Btn">
                    <Button label="Cancel" className="Btn__Transparent" />
                    <Button disabled={loading} label="Proceed" className="Btn__Dark" />
                </div>
            </div> */}
        </>
    );
};

export default AddBulkBranch;
